import { Routes, provideRouter, withViewTransitions } from '@angular/router';
import { provideZoneChangeDetection } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { provideFormFactoryConfig } from 'ngx-dynamic-forms-factory';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideIcons } from '@ng-icons/core';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ICONS,
  provideEnvironment,
  ToastService,
} from 'libs/core/src/public-api';
import {
  MissingTranslationHandler,
  provideTranslateService,
} from '@ngx-translate/core';
import { FormFactoryOptions } from 'libs/core/src/public-api';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CustomMissingTranslationHandler } from 'libs/core/src/public-api';
import { AppTheme } from './theme/theme';
import { environment } from '../../environments/environment';
// import { provideAbilities } from './permissions/abilities';
export interface CoreOptions {
  routes: Routes;
  interceptors?: any[];
}

export function provideCore({ routes, interceptors = [] }: CoreOptions) {
  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: 'dark',
        },
      },
    }),
    provideTranslateService({
      fallbackLang: 'sr',
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    }),
    provideFormFactoryConfig(FormFactoryOptions),
    provideHttpClient(withInterceptors(interceptors)),
    provideIcons(ICONS),
    // provideAbilities(),
    ConfirmationService,
    MessageService,
    ToastService,
    provideEnvironment(environment),
  ];
}
